export { Suggestions } from './Suggestions';

export {
  type SuggestionCtaWrapperProps,
  SuggestionCtaWrapper,
} from './SuggestionCtaWrapper';

export type {
  SuggestionsProps,
  SuggestionsCardProps,
  BaseCardComponentProps,
  Offer,
} from './types';

export {
  type MarketingCardSchema,
  renderMarketingCard,
  MarketingCardSkeleton,
} from './MarketingCard';
